/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Document,
  Document$inboundSchema,
  Document$Outbound,
  Document$outboundSchema,
} from "./document.js";

export type RetrieveDocumentsResponse = {
  documents: Array<Document>;
  scores?: { [k: string]: number } | undefined;
};

/** @internal */
export const RetrieveDocumentsResponse$inboundSchema: z.ZodType<
  RetrieveDocumentsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  documents: z.array(Document$inboundSchema),
  scores: z.record(z.number().int()).optional(),
});

/** @internal */
export type RetrieveDocumentsResponse$Outbound = {
  documents: Array<Document$Outbound>;
  scores?: { [k: string]: number } | undefined;
};

/** @internal */
export const RetrieveDocumentsResponse$outboundSchema: z.ZodType<
  RetrieveDocumentsResponse$Outbound,
  z.ZodTypeDef,
  RetrieveDocumentsResponse
> = z.object({
  documents: z.array(Document$outboundSchema),
  scores: z.record(z.number().int()).optional(),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace RetrieveDocumentsResponse$ {
  /** @deprecated use `RetrieveDocumentsResponse$inboundSchema` instead. */
  export const inboundSchema = RetrieveDocumentsResponse$inboundSchema;
  /** @deprecated use `RetrieveDocumentsResponse$outboundSchema` instead. */
  export const outboundSchema = RetrieveDocumentsResponse$outboundSchema;
  /** @deprecated use `RetrieveDocumentsResponse$Outbound` instead. */
  export type Outbound = RetrieveDocumentsResponse$Outbound;
}

export function retrieveDocumentsResponseToJSON(
  retrieveDocumentsResponse: RetrieveDocumentsResponse,
): string {
  return JSON.stringify(
    RetrieveDocumentsResponse$outboundSchema.parse(retrieveDocumentsResponse),
  );
}

export function retrieveDocumentsResponseFromJSON(
  jsonString: string,
): SafeParseResult<RetrieveDocumentsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RetrieveDocumentsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RetrieveDocumentsResponse' from JSON`,
  );
}
